import { useState, useEffect, useRef } from "react";
import { getCombosJWT } from "../api/endpoints";

// Mapeo de endpoints .aspx de autocomplete a tipos de catálogo del nuevo backend
const ASPX_TO_AUTOCOMPLETE = {
    'api_reparticiones.aspx': 'reparticiones',
    'api_personal.aspx': 'personal',
    'api_contraparte.aspx': 'contraparte',
    'api_impuestos.aspx': 'impuestos',
    'api_juzgados.aspx': 'juzgados',
    'api_jurisdicciones.aspx': 'jurisdicciones',
    'api_modulos.aspx': 'modulos',
    'api_areas.aspx': 'areas',
    'api_objetos_reclamo.aspx': 'objetos_reclamo',
    'api_tipos_proceso.aspx': 'tipos_proceso',
    'api_estados_proceso.aspx': 'estados_proceso',
    'api_etapas_proceso.aspx': 'etapas_proceso',
    'api_caracteres.aspx': 'caracteres',
    'api_tipos_archivo.aspx': 'tipos_archivo',
    'api_tipo_movimientos.aspx': 'tipo_movimientos',
};

function detectAutocompleteType(endpoint) {
    if (typeof endpoint === 'function') return null;
    const ep = String(endpoint || '').toLowerCase().replace(/^\/+/, '');

    for (const [aspx, tipo] of Object.entries(ASPX_TO_AUTOCOMPLETE)) {
        if (ep.startsWith(aspx.toLowerCase())) return tipo;
    }

    return null;
}

export function useAutocompleteData(endpoint, initial = "") {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const abortRef = useRef(null);

    const fetchOptions = (query) => {
        if (abortRef.current) abortRef.current.abort();
        const ctrl = new AbortController();
        abortRef.current = ctrl;

        setLoading(true);

        const comboType = detectAutocompleteType(endpoint);

        if (comboType) {
            // Usar nuevo backend JWT
            getCombosJWT(comboType, query || '', 50)
                .then((data) => {
                    if (ctrl.signal.aborted) return;
                    const arr = Array.isArray(data)
                        ? data
                        : data?.items || data?.result || data?.data || [];
                    setOptions(arr);
                })
                .catch(() => {
                    // silencioso
                })
                .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
        } else if (typeof endpoint === 'function') {
            // Endpoint es una función custom - llamarla directamente
            // (usado por componentes que ya pasaron funciones JWT)
            const result = endpoint(query);
            if (result && typeof result.then === 'function') {
                result
                    .then((data) => {
                        if (ctrl.signal.aborted) return;
                        const arr = Array.isArray(data)
                            ? data
                            : data?.items || data?.result || data?.data || [];
                        setOptions(arr);
                    })
                    .catch(() => {})
                    .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
            } else {
                setLoading(false);
            }
        } else {
            console.warn(`[useAutocompleteData] Endpoint no mapeado: ${endpoint}`);
            setOptions([]);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOptions(initial);
        return () => {
            if (abortRef.current) abortRef.current.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endpoint]);

    return { options, loading, fetchOptions };
}
